import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@mui/material";
import mixpanel from "mixpanel-browser";
import React from "react";

import { AccountItemLine } from "./AccountItem";
import { DSButton, DSLinkButton } from "../design-system/molecules";
import { instantiateCustomerPortal } from "./../../api/Billing";

export function SubscriptionDetails({
  user,
  setShouldShowCancelSubscriptionModal,
}) {
  const renderBillingInfo = (user) => {
    const details = user?.account?.accountDetails;

    const { planName, quantity, billingFrequency, planPrice } =
      details || {};
    if (!planName || !quantity || !billingFrequency || !planPrice) {
      return "Pro";
    }

    const displayPlanName =
      planName === "Scribenote Unlimited"
        ? "Scribenote Pro"
        : planName;

    const timesQty = quantity > 1 ? ` (x${quantity})` : "";
    const per = billingFrequency === "yearly" ? "year" : "month";

    return `${displayPlanName}${timesQty}, recurring ${billingFrequency} (${planPrice} / ${per})`;
  };

  return (
    <>
      <div className="flex-1 divide-y divide-secondary">
        <AccountItemLine
          title="Plan Type:"
          dataTestId="subscription-plan-type"
        >
          <span className="text-primary">
            {renderBillingInfo(user)}
          </span>
          {user?.account?.accountDetails?.isCanceled && (
            <strong className="text-sm text-danger"> Canceled</strong>
          )}
        </AccountItemLine>
        <AccountItemLine
          title="Upcoming and past invoices"
          dataTestId="subscription-invoices"
        >
          <DSLinkButton
            dataTestId="view-invoices-button"
            onClick={() => {
              mixpanel.track("View upcoming invoices clicked");
              instantiateCustomerPortal();
            }}
          >
            See details
          </DSLinkButton>

          <Tooltip
            arrow
            placement="top"
            title={
              "This amount may include prorated costs from the current billing cycle. Click Manage Plan to see a detailed breakdown."
            }
          >
            <FontAwesomeIcon
              className="inline-block text-secondary hover:text-brand ml-sm"
              icon={faQuestionCircle}
              size="lg"
            />
          </Tooltip>
        </AccountItemLine>

        <div className="text-xs text-secondary pt-xs">
          To update billing and subscription details, view past
          invoices and more, please click <strong>Manage Plan</strong>
          .
        </div>
      </div>
      {user?.account?.isTeamsCustomer ? null : (
        <div
          id="accountSubscriptionOptions"
          className="flex flex-row md:flex-col md:items-end items-center justify-center gap-sm"
        >
          <Tooltip
            title={
              "Change plan, update billing details, update card information, change billing frequency, view past invoices, etc."
            }
            arrow
          >
            <span>
              <DSButton
                dataTestId="manage-plan-button"
                onClick={async () => {
                  mixpanel.track("Manage Plan Clicked");
                  instantiateCustomerPortal();
                }}
              >
                Manage Plan
              </DSButton>
            </span>
          </Tooltip>

          {!user?.account?.accountDetails?.isCanceled ? (
            <DSLinkButton
              variant="danger"
              dataTestId="cancel-subscription-button"
              onClick={() => {
                setShouldShowCancelSubscriptionModal(true);
                mixpanel.track("Cancel Subscription Clicked");
              }}
            >
              Cancel Subscription
            </DSLinkButton>
          ) : null}
        </div>
      )}
    </>
  );
}
